import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import instance from "../../api/api.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { FilterMatchMode } from "primereact/api";

import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate } from "react-router-dom";
// import { Help } from "../../utils/index.js";
import { styleIcone } from "../../shared";
import { IoMdEye } from "react-icons/io";
import { MdOutlinePayment } from "react-icons/md";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import MenuPoint from "../../shared/compoments/MenuPoint.jsx";

const options = [
  {
    name: "Voir plus",
    path: "/Historique_paiement/",
    icone: <IoMdEye style={styleIcone} />,
    isIdData: true,
  },
];

function ListerPayements() {
  //   const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterPayments, setFilterPayments] = useState([]);
  const [btnVisible, setBtnVisible] = useState("Toutes");
  const VALUE_BTN = [
    {
      value: "en attente",
    },
    {
      value: "Confirmer",
    },
    {
      value: "en cours",
    },
    {
      value: "livrée",
    },
    {
      value: "en attente d'annulation",
    },
    {
      value: "annulée",
    },
  ];
  const handleFilterCommande = (value) => {
    console.log("handleFilterCommande", value);
    setPayments(filterPayments.filter((item) => item.statut === value));
    setBtnVisible(value);
  };
  const handleAllPayments = () => {
    setPayments(filterPayments);
    setBtnVisible("Toutes");
  };

  const ITEMSFILTER = [
    "created_at",
    "user.nom",
    "user.phone",
    "total",
    "reference",
  ];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const itemsAtExportInExcel = payments.map((obj) => {
    const {
      id,
      user_id,
      commentaire,
      created_at,
      produits,
      updated_at,
      deleted_at,
      user,
      ...rest
    } = obj;
    return rest;
  });
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(itemsAtExportInExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "files");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });

      module.default.saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };
  useEffect(() => {
    const getListPayments = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("payments");
        console.log("Payments", response.data.data);
        setPayments(response.data.data.sort((a, b) => b.flag - a.flag));
        setFilterPayments(response.data.data.sort((a, b) => b.flag - a.flag));
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListPayments();
  }, []);
  return (
    <AllCompomentShared
      libelleHeaderComp={"Historique des paiements"}
      titleStatisticHeaderComp={"Nombre de paiements"}
      nbreTotalStatistiqueComp={payments.length}
      SearchTableIsBtnExcel={true}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      SearchTableLibelleBtn={"Format excel"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      SearchTableExportExcel={exportExcel}
      iconeStatistiqueHeader={<MdOutlinePayment fontSize={"2em"} />}
      isLoading={isLoading}>
      <PaiementDatatable
        items={payments}
        isVisibleColumn={true}
        filters={filters}
        ITEMSFILTER={ITEMSFILTER}
      />
    </AllCompomentShared>
  );
}
export function PaiementDatatable({
  items,
  isVisibleColumn,
  ITEMSFILTER,
  filters,
}) {
  // const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const dt = useRef(null);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [idPaiement, setIdPaiement] = useState("");
  const [valueOfCategorie, setValueOfCategorie] = useState("");
  const [visibleModifier, setVisibleModifier] = useState(false);
  const [isLoadingChange, setIsLoadingChange] = useState(false);
  const [dataModif, setDataModif] = useState({
    libelle: "",
  });

  const seeDetailPaiement = (id) => {
    console.log("idPaiement", id);
    // dispatch(removeFlagPayments(id));
    navigate(`/Historique_paiement/${id}`);
  };
  const handleModification = async () => {
    setIsLoadingChange(true);
    try {
      const response = await instance.put("Payments/" + idPaiement, dataModif);
      console.log("CATEGORIE_MODIFIER", response);
      const element = items.find((item) => item.id === idPaiement);
      element.libelle = dataModif.libelle;
      setIsLoadingChange(false);
    } catch (error) {
      console.log(error);
      setIsLoadingChange(false);
    }
  };
  const handleDeleteCategorie = async () => {
    setIsLoadingChange(true);
    try {
      const response = await instance.delete("Payments/" + idPaiement);
      console.log("CATEGORIE_DELETE", response);
      if (response.data.status === true) {
        const element = items.findIndex((item) => item.id === idPaiement);
        items.splice(element, 1);
        setIsLoadingChange(false);
        setVisible(false);
        MySwal.fire({
          title: `Le produit a été supprimé avec succès `,
          icon: "success",
          showConfirmButton: true,
        });
      }
      if (response.data.status === false) {
        MySwal.fire({
          title: response.data.message.libelle[0],
          icon: "info",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoadingChange(false);
    }
  };
  const detailsDate = (rowData) => {
    return <p>{new Date(rowData.created_at).toLocaleDateString("fr")}</p>;
  };
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  // const detailsInfo = (rowData) => {
  //   return (
  //     <div className="d-flex align-items-center gap-1 justify-content-center flex-wrap">
  //       <AiFillEye
  //         fontSize="1.5em"
  //         onClick={() => seeDetailPaiement(rowData.id)}
  //       />
  //     </div>
  //   );
  // };

  // const renderHeader = () => {
  //   const itemsAtExportInExcel = items.map((obj) => {
  //     const {
  //       id,
  //       user_id,
  //       commentaire,
  //       created_at,
  //       produits,
  //       updated_at,
  //       deleted_at,
  //       user,
  //       ...rest
  //     } = obj;
  //     // rest.totalProduit = obj.produits.length;
  //     // rest.client = obj.user.nom + " " + obj.user.prenom;
  //     // rest.contact = obj.user.phone;
  //     // rest.email = obj.user.email;
  //     // rest.date_commande = obj.date_commande.split(" ")[0];
  //     // let produit = [];
  //     // obj.produits.forEach((element) => {
  //     //   produit.push(element.produit.nom + " " + "(" + element.quantite + ")");
  //     // });
  //     // rest.produit = produit.join(", ");
  //     // rest.total_produit = obj.produits.length;
  //     return rest;
  //   });
  //   const exportExcel = () => {
  //     import("xlsx").then((xlsx) => {
  //       const worksheet = xlsx.utils.json_to_sheet(itemsAtExportInExcel);
  //       const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  //       const excelBuffer = xlsx.write(workbook, {
  //         bookType: "xlsx",
  //         type: "array",
  //       });

  //       saveAsExcelFile(excelBuffer, "files");
  //     });
  //   };

  //   const saveAsExcelFile = (buffer, fileName) => {
  //     import("file-saver").then((module) => {
  //       let EXCEL_TYPE =
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  //       let EXCEL_EXTENSION = ".xlsx";
  //       const data = new Blob([buffer], {
  //         type: EXCEL_TYPE,
  //       });

  //       module.default.saveAs(
  //         data,
  //         fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
  //       );
  //     });
  //   };
  //   return (
  //     <div className="conteneur-search">
  //       <Dialog
  //         header="Voulez-vous vraiment supprimer ce produit."
  //         visible={visible}
  //         style={{ width: "50vw" }}
  //         onHide={() => {
  //           if (!visible) return;
  //           setVisible(false);
  //         }}
  //       >
  //         <button
  //           onClick={() => handleDeleteCategorie()}
  //           className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           {isLoadingChange ? "Chargement..." : "Confirmer"}
  //         </button>
  //         <button
  //           onClick={() => setVisible(false)}
  //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           Annuler
  //         </button>
  //       </Dialog>
  //       <Dialog
  //         header="Modification de la catégorie"
  //         visible={visibleModifier}
  //         style={{ width: "50vw" }}
  //         onHide={() => {
  //           if (!visibleModifier) return;
  //           setVisibleModifier(false);
  //         }}
  //       >
  //         <input
  //           type="text"
  //           defaultValue={valueOfCategorie}
  //           onChange={(e) =>
  //             setDataModif({ ...dataModif, libelle: e.target.value })
  //           }
  //         />
  //         <button
  //           onClick={() => handleModification()}
  //           className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           {isLoadingChange ? "Chargement..." : "Confirmer"}
  //         </button>
  //         <button
  //           onClick={() => setVisibleModifier(false)}
  //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           Annuler
  //         </button>
  //       </Dialog>
  //       {
  //         isVisibleColumn &&
  //         <div className="btn-upload-file">
  //         <Button
  //           type="button"
  //           label="Excel format"
  //           icon="pi pi-file-excel"
  //           style={{
  //             border: "none",
  //             color: "white",
  //             margin: "1em 0",
  //           }}
  //           onClick={exportExcel}
  //           data-pr-tooltip="XLS"
  //         />
  //       </div>
  //       }

  //     </div>
  //   );
  // };
  // const header = renderHeader();

  return (
    <div>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={ITEMSFILTER}>
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Date de paiement"
              body={detailsDate}></Column>
            <Column
              field="facture.reference"
              style={{ textAlign: "center" }}
              header="Référence facture"></Column>
            {isVisibleColumn && (
              <Column
                field="facture.contract.client.nom"
                style={{ textAlign: "center" }}
                header="Locataire"></Column>
            )}
            {isVisibleColumn && (
              <Column
                field="facture.contract.propriety.nom"
                style={{ textAlign: "center" }}
                header="Biens"></Column>
            )}

            <Column
              field="amount_paid"
              style={{ textAlign: "center" }}
              header="Montant (Fcfa)"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListerPayements;
